import { Stack } from '@grubhubprod/gh-cookbook-react';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { InsightsDashboard } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsDashboard/InsightsDashboard';
import { InsightsDashboardLoader } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsDashboardLoader/InsightsDashboardLoader';
import { useBusinessInsightsContext } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/hooks/useBusinessInsightsContext';
import { getConfig } from 'src/utilities/config';

export function InsightsDashboardSection(): JSX.Element {
  const {
    authorizationKey,
    authorizationToken,
    dashboardId,
    isLoading: isDashboardConfigLoading,
    isError,
  } = useBusinessInsightsContext();

  const [isDashboardLoading, setIsDashboardLoading] = useState(
    isDashboardConfigLoading
  );

  const config = getConfig();

  const dashboardConfig = useMemo(() => {
    if (!authorizationKey || !authorizationToken || !dashboardId || isError) {
      return null;
    }

    return {
      authKey: authorizationKey,
      authToken: authorizationToken,
      dashboardId,
      apiHost: config.luzmo.apiHost,
      appServer: config.luzmo.appServer,
    };
  }, [
    authorizationKey,
    authorizationToken,
    dashboardId,
    isError,
    config.luzmo.apiHost,
    config.luzmo.appServer,
  ]);

  const onLoaded = useCallback(() => {
    setIsDashboardLoading(false);
  }, []);

  const showLoader = isDashboardConfigLoading || isDashboardLoading;

  useEffect(() => {
    if (isDashboardConfigLoading) {
      setIsDashboardLoading(isDashboardConfigLoading);
    }
  }, [isDashboardConfigLoading]);

  return (
    <Stack y={showLoader ? 'md' : 'none'}>
      {showLoader && <InsightsDashboardLoader />}
      {!!dashboardConfig && (
        <Stack height={showLoader ? '0' : 'auto'}>
          <InsightsDashboard
            luzmoConfig={dashboardConfig}
            onLoaded={onLoaded}
          />
        </Stack>
      )}
    </Stack>
  );
}
